import withFormikWrapper from '../formik/withFormikWrapper';
import CleanYearSelector from '../cleanYearSelector';

export const CleanFormikYearSelector = withFormikWrapper()(CleanYearSelector);
